
import { create } from 'zustand';

export type CreateWorkflowDialogSource =
  | 'header'
  | 'command-palette'
  | 'workflow-list-hero'
  | 'workflow-list-empty-state'
  | 'workflow-list-toolbar'
  | 'deep-link'
  | 'unknown';

interface OpenOpts {
  prompt?: string | null;
  source?: CreateWorkflowDialogSource;
  /** When true, the designer opens with the template gallery auto-shown after create. */
  openTemplates?: boolean;
}

interface CreateWorkflowDialogState {
  isOpen: boolean;
  pendingPrompt: string | null;
  source: CreateWorkflowDialogSource;
  openTemplates: boolean;
  open: (opts?: OpenOpts) => void;
  close: () => void;
}

export const useCreateWorkflowDialogStore = create<CreateWorkflowDialogState>((set) => ({
  isOpen: false,
  pendingPrompt: null,
  source: 'unknown',
  openTemplates: false,
  open: (opts) =>
    set({
      isOpen: true,
      pendingPrompt: opts?.prompt ?? null,
      source: opts?.source ?? 'unknown',
      openTemplates: opts?.openTemplates ?? false,
    }),
  close: () => set({ isOpen: false, pendingPrompt: null, source: 'unknown', openTemplates: false }),
}));

/** Open the create-workflow dialog from non-React code (route redirects, event handlers). */
export const openCreateWorkflowDialog = (opts?: OpenOpts) =>
  useCreateWorkflowDialogStore.getState().open(opts);

/** Close the create-workflow dialog from non-React code. */
export const closeCreateWorkflowDialog = () =>
  useCreateWorkflowDialogStore.getState().close();
